<template>
    <div class="flex flex-column gap-2 px-2 mb-3" :class="(screenSize === 'xs' || screenSize === 'sm') ? 'overflow-x-scroll' : ''">
        <div class="flex flex-row align-items-center justify-content-left gap-2 xl:flex-row lg:flex-row md:flex-row">
            <SelectButton v-model="selectedColumns" :options="columns" optionLabel="field" multiple aria-labelledby="multiple" class="flex">
                <template #option="slotProps">
                    <span class="text-xs py-1 white-space-nowrap">{{ slotProps.option.field }}</span>
                </template>
            </SelectButton>
            <Button v-if="isUserInGroup('admin')" :label="(screenSize === 'xs' || screenSize === 'sm') ? '' : 'Экспорт'" 
                icon="pi pi-upload" size="small" text @click="exportCSV($event)" severity="info" class="flex"/>
            <Button :label="(screenSize === 'xs' || screenSize === 'sm') ? '' : 'Сбросить'"
                icon="pi pi-filter" size="small" @click="resetFilter" text severity="info" class="flex mr-2"/>
        </div>
        <div class="flex flex-row align-items-center justify-content-left gap-2 xl:flex-row lg:flex-row md:flex-row">
            <Chip @click="filterFreeTransfers"
                :class="isActiveFilter('free') ? 'bg-primary text-white' : ''" class="flex py-1 text-600 cursor-pointer text-xs font-medium">
                <span class="text-xs font-medium">Бесплатные</span>
                <i v-if="isActiveFilter('free')" class="pi pi-times cursor-pointer text-xs"></i>
                <i v-else class="pi pi-filter cursor-pointer text-xs"></i>
            </Chip>
            <Chip @click="filterActiveTransfers"
                :class="isActiveFilter('status') ? 'bg-primary text-white' : ''" class="flex py-1 text-600 cursor-pointer text-xs font-medium">
                <span class="text-xs font-medium">Активные</span>
                <i v-if="isActiveFilter('status')" class="pi pi-times cursor-pointer text-xs"></i>
                <i v-else class="pi pi-filter cursor-pointer text-xs"></i>
            </Chip>
        </div>
    </div>

    <DataTable v-if="transfers" :value="transfers" lazy paginator :rows="10" v-model:filters="filters" ref="dt" dataKey="id"
        :totalRecords="totalRecords" :loading="loading" @page="onPage($event)" @sort="onSort($event)" responsiveLayout="scroll"
        @filter="onFilter($event)" filterDisplay="menu" 
        :globalFilterFields="['sender_user_id', 'get_merchant_merchant_id', 'send_merchant_merchant_id', '_id', 'status', 'sender_amount_', 'sender_currency_code', 'sender_bank_code', 'recipient_amount_', 'recipient_currency_code', 'recipient_bank_code', 'payment_system', 'date_created']" 
        v-model:selection="selectedTransfers" :selectAll="selectAll" @select-all-change="onSelectAllChange"
        @row-select="onRowSelect" @row-unselect="onRowUnselect" class="mb-3"
        :rowsPerPageOptions="[5, 10, 20, 50, 100, 200, 300, 400, 500, 1000]">

        <Column field="_id" header="" filterMatchMode="contains" :showFilterMenu="true" :showFilterMatchModes="false">
            <template #header>
            <span class="text-xs">ID</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()"
                    class="p-column-filter w-12rem" placeholder="Найти" />
            </template>
            <template #body="{ data }">
                <span class="text-sm flex flex-row" @click="copy(data.id)">
                    <span class="text-xs flex my-auto overflow-hidden" style="max-width:4em">
                        <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                            {{ data.id }}
                        </span>
                    </span>...
                    <span class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                </span>
            </template>
        </Column>

        <Column field="sender_user_id" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true" :exportable="false">
            <template #header>
            <span class="text-xs">Польз.</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter w-12rem" placeholder="Найти" />
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-1 text-xs white-space-nowrap align-items-center">
                    <AvatarGroup v-if="getTelegramPhoto(data.sender.user_id)" @click="go_to_user(data.sender.user_id)" class="flex cursor-pointer">
                        <Avatar :image="getTelegramPhoto(data.sender.user_id)" shape="circle" />
                    </AvatarGroup>
                    <AvatarGroup v-else @click="go_to_user(data.sender.user_id)" class="flex cursor-pointer">
                        <Avatar icon="pi pi-user" shape="circle" />
                    </AvatarGroup>
                    <span v-if="users && users[data.sender.user_id]" @click="go_to_user(data.sender.user_id)" class="flex text-900 hover:text-primary cursor-pointer">
                        {{ get_short_name(users[data.sender.user_id].name) }} 
                    </span>
                    <span v-else class="flex text-xs" @click="go_to_user(data.sender.user_id)">
                        {{ get_short_id(data.sender.user_id) }}
                    </span>
                    <i icon="pi pi-verify" v-if="users && users[data.sender.user_id] && users[data.sender.user_id].verified" class="pi pi-check-circle text-green-500 text-xs" v-tooltip.top="'Верифицирован'" />
                    <!-- <Button icon="pi pi-external-link" @click="go_to_user(data.sender.user_id)" size="small" outlined severity="info" class="border-0"/> -->
                    <Button icon="pi pi-filter" @click="filterUser(data.sender.user_id)" size="small" outlined severity="info" class="border-0"/>
                </div>
            </template>
            <template #footer="{ data }">
                <div v-if="stat.uniq_senders" class="flex flex flex-column">
                    <span class="text-xs mb-2">Польз.</span>
                    <span>{{ stat.uniq_senders }}</span>
                </div>
            </template>
        </Column>

        <!--польз создания для выгрузки-->
        <Column field="sender.user_id" header="user_id" class="hidden">
            <template #body="slotProps">
                <span class="text-sm">{{ slotProps?.data?.sender?.user_id }}</span>
            </template>
        </Column>

        <Column field="" header="" >
            <template #header>
            <span class="text-xs">Проц</span>
            </template>
            <template #body="{ data }">
                <span :class="(getStep(data, 1)) ? 'bg-green-300' : 'surface-300'" class="border-round-left w-1 h-1 px-1 border-right-1 border-white"></span>
                <span :class="(getStep(data, 2)) ? 'bg-green-300' : 'surface-300'" class="w-1 h-1 px-1 border-right-1 border-white"></span>
                <span :class="(getStep(data, 3)) ? 'bg-green-300' : 'surface-300'" class="w-1 h-1 px-1 border-right-1 border-white"></span>
                <span :class="(getStep(data, 4)) ? 'bg-green-300' : 'surface-300'" class="border-round-right w-1 h-1 px-1"></span>
            </template>
        </Column>

        <Column field="source">
            <template #header>
            <span class="text-xs">Получ.</span>
            </template>
            <template #body="{ data }"> 
                <span class="flex flex-row">
                <!-- {{ data?.risk }} -->
                    <Knob :modelValue="getRiskScore(data)" readonly 
                        :strokeWidth="10" :size="30" :min="0" :max="100"
                        class="mr-2" v-tooltip.top="getRiskDetails(data)"
                        :valueColor="getClassFromRiskLevel(data)"/>
                    <Button :icon="getTranferTypeIcon(data.type)" v-tooltip.top="getTranferTypeLabel(data.type)"
                        :severity="getTranferSeverity(data.type)" size="small" class="border-0 p-0 text-xs" />
                    <Button :icon="(data.source=='web') ? 'pi pi-globe' : 'pi pi-telegram'" v-tooltip.top="'Источник: ' + ((data.source=='web') ? 'Сайт' : (data.source=='tgapp') ? 'TG' : data.source)"
                        severity="secondary" :disabled="true" size="small" outlined  class="border-0" />
                    <Button @click="goToTelegram(getTelegram(data.sender.user_id))" 
                        :severity="(users && users[data.sender.user_id] && getTelegram(data.sender.user_id)) ? 'info' : 'secondary'" :disabled="!getTelegram(data.sender.user_id)"
                        icon="pi pi-telegram"  size="small" outlined  class="border-0" />
                    <Button @click="goToSendpulse(getSendpulse(data.sender.user_id))" 
                        :severity="(users && users[data.sender.user_id] && getSendpulse(data.sender.user_id)) ? 'info' : 'secondary'" :disabled="!getSendpulse(data.sender.user_id)"
                        icon="pi pi-comments"  size="small" outlined class="border-0"/>
                    <Button @click="goToNotion(getNotion(data.sender.user_id))" 
                        :severity="(users && users[data.sender.user_id] && getNotion(data.sender.user_id)) ? 'info' : 'secondary'" :disabled="!getNotion(data.sender.user_id)"
                        icon="pi pi-id-card"  size="small" outlined class="border-0"/>
                    <Button @click="goToWhatsApp(getWhatsApp(data.sender.user_id))" 
                        :severity="(users && users[data.sender.user_id] && getWhatsApp(data.sender.user_id)) ? 'info' : 'secondary'" :disabled="!getWhatsApp(data.sender.user_id)"
                        icon="pi pi-whatsapp"  size="small" outlined  class="border-0" />
                    <Button @click="openPopupImage(getReceiptFromSender(data.sender.user_id, data.id))" 
                        :severity="(receipts && getReceiptFromSender(data.sender.user_id, data.id)) ? 'success' : 'secondary'" :disabled="!getReceiptFromSender(data.sender.user_id, data.id)"
                        :class="(receipts && getReceiptFromSender(data.sender.user_id, data.id)) ? 'text-green-600 bg-green-50' : ''"
                        icon="pi pi-paperclip" size="small" outlined class="border-0"/>
                    <Button v-if="users && users[data.sender.user_id] && users[data.sender.user_id].recipients && users[data.sender.user_id].recipients"
                        :label="getLength(users[data.sender.user_id].recipients)" @click="openRecipientsPopup(users[data.sender.user_id].recipients)"
                        icon="pi pi-user" size="small" outlined severity="info" class="border-0" />
                    <Button v-if="data.sender.description || data.recipient.description" icon="pi pi-file-edit" size="small" class="border-round-md border-round-lg border-0 text-green-600 bg-green-50" outlined 
                        @click="openPopupText(data.sender.description, data.recipient.description)" />
                    <Tag v-if="data.free" value="free" severity="info" class="flex text-xs p-1" />
                </span>
            </template>
            <template #footer="{ data }">
                <div v-if="stat.obj_sources" class="flex flex flex-column">
                    <span class="text-xs mb-2">Ист.</span>
                    <span v-for="(type, i) of stat.obj_sources" class="text-xs mb-1 font-medium white-space-nowrap">
                        {{ (i=='web') ? 'Сайт' : '' }}
                        {{ (i=='tgapp') ? 'TG' : '' }}
                        - {{ type }}
                    </span>
                </div>
            </template>
        </Column>

        <Column field="get_merchant_merchant_id" :exportable="false" filterMatchMode="contains" :showFilterMatchModes="false">
            <template #header>
            <span class="text-xs">Прием</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <MultiSelect v-model="filterModel.value" @change="filterCallback()" :options="merchants" optionLabel="name" option placeholder="Все" class="p-column-filter" :maxSelectedLabels="1">
                    <template #option="slotProps">
                        <div class="flex align-items-center gap-2">
                            <span>{{ slotProps.option.name }}</span>
                        </div>
                    </template>
                </MultiSelect>
            </template>
            <template #body="{ data }">
                <span class="flex text-xs white-space-nowrap">
                    <AvatarGroup class="flex">
                        <Avatar v-if="data.get && data.get.code" :image="getPaySysImage(data.get.code)" class="flex mr-2" style="width:22px!important;height:22px!important;" />
                        <Avatar v-if="data.sender && data.sender.bank_code" :image="getBankImage(data.sender.bank_code)" v-tooltip.top="getBankTitle(data.sender.bank_code)"
                            class="flex mr-2" style="width:22px!important;height:22px!important;" />
                    </AvatarGroup>
                    <span v-if="data.get.type=='merchant'" class="flex flex-row align-items-center">
                        <span v-if="merchants" class="flex cursor-pointer hover:text-primary" @click="goToMerchant(data.get.merchant.merchant_id)">
                            {{ get_short_name(getMerchantName(data.get.merchant.merchant_id)) }}
                        </span>
                        <span v-else class="flex">{{ get_short_id(data.get_merchant_id) }}</span>
                    </span>
                    <span v-else class="flex flex-row align-items-center">
                        <span>{{ get_short_name(getPaySysTitle(data.get.code)) }}</span>
                    </span>
                </span>
            </template>
        </Column>

        <Column field="send_merchant_merchant_id" :exportable="false" filterMatchMode="contains" :showFilterMatchModes="false">
            <template #header>
            <span class="text-xs">Выплата</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <MultiSelect v-model="filterModel.value" @change="filterCallback()" :options="merchants" optionLabel="name" option placeholder="Все" class="p-column-filter" :maxSelectedLabels="1">
                    <template #option="slotProps">
                        <div class="flex align-items-center gap-2">
                            <span>{{ slotProps.option.name }}</span>
                        </div>
                    </template>
                </MultiSelect>
            </template>
            <template #body="{ data }">
                <span class="flex text-xs white-space-nowrap">
                    <AvatarGroup class="flex">
                        <Avatar v-if="data.send && data.send.code" :image="getPaySysImage(data.send.code)" class="flex mr-2" style="width:22px!important;height:22px!important;" />
                        <Avatar v-if="data.recipient && data.recipient.bank_code" :image="getBankImage(data.recipient.bank_code)" v-tooltip.top="getBankTitle(data.recipient.bank_code)"
                            class="flex mr-2" style="width:22px!important;height:22px!important;" />
                    </AvatarGroup>
                    <span v-if="data.send.type=='merchant'" class="flex flex-row align-items-center">
                        <span v-if="merchants" class="flex cursor-pointer hover:text-primary" @click="goToMerchant(data.send.merchant.merchant_id)">
                            {{ get_short_name(getMerchantName(data.send.merchant.merchant_id)) }}
                        </span>
                        <span v-else class="flex">{{ get_short_id(data.send.merchant.merchant_id) }}</span>
                        <Button v-if="receipts && getReceiptFromMerchant(data.send.merchant.merchant_id, data.id)" icon="pi pi-paperclip" @click="openPopupImage(getReceiptFromMerchant(data.send.merchant.merchant_id, data.id))" size="small" class="flex border-0 text-green-600 bg-green-50" outlined severity="success" />
                    </span>
                    <span v-else class="flex flex-row align-items-center">
                        <span>{{ get_short_name(getPaySysTitle(data.send.code)) }}</span>
                    </span>
                </span>
            </template>
        </Column>

        <!--имя мерчанта приема для выгрузки-->
        <Column field="get_merchant_name" header="Мерчант получения" class="hidden">
            <template #body="{ data }"> 
                <span class="text-sm">{{ data.get_merchant_name }}</span>
            </template>
        </Column>

        <!--имя мерчанта отправки для выгрузки-->
        <Column field="send_merchant_name" header="Мерчант отправки" class="hidden">
            <template #body="{ data }"> 
                <span class="text-sm">{{ data.send_merchant_name }}</span>
            </template>
        </Column>

        <!--короткий id для выгрузки-->
        <Column field="csv_id" header="Short ID" class="hidden">
            <template #body="{ data }"> 
                <span class="text-sm">{{ data.csv_id }}</span>
            </template>
        </Column>

        <Column field="status" header="" :showFilterMenu="true" :showFilterMatchModes="false" :showApplyButton="false">
            <template #header>
            <span class="text-xs">Стат.</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="statuses" placeholder="Все" class="p-column-filter" :showClear="false">
                    <template #option="slotProps">
                        <div :class="'status-'+slotProps.option" 
                            class="inline-block py-1 px-2 text-xs border-round-md font-semibold border-2 surface-border cursor-pointer text-white font-medium align-items-center" >
                            <span class="flex">{{getStatusLabel(slotProps.option)}}</span>
                        </div>
                    </template>
                </Dropdown>
            </template>
            <template #body="{ data }">
                <div :class="'status-'+data.status" 
                    class="inline-block py-1 px-1 text-xs border-round-md border-2 surface-border text-white align-items-center white-space-nowrap" >
                    <span class="flex text-xs">{{getStatusLabel(data.status)}}</span>
                </div>
            </template>
        </Column>

        <Column field="_id" header="" :exportable="false">
            <template #header>
            <span class="text-xs">Подробно</span>
            </template>
            <template #body="slotProps">
                <div class="flex flex-row">
                    <Button label="Подробно" @click='detail_page(slotProps.data.id, false)' size="small" class="text-xs mr-1 border-round-md" severity="info"/>
                    <Button label="" @click='detail_page(slotProps.data.id, true)' size="small" icon="pi pi-external-link" outlined class="border-none border-round-md" severity="info"/>
                    <Button label="Op" @click='toOps(slotProps.data.id)' v-if="isUserInGroup('admin')" size="small" outlined icon="pi pi-external-link" class="border-none border-round-md" severity="info"/>
                </div>
            </template>
        </Column>

        <!-- <Column field="type" header="" >
            <template #header>
            <span class="text-xs">Тип</span>
            </template>
            <template #body="{ data }">
                <span class="text-xs" :class="getTranferTypeClass(data.type)" >
                    {{ getTranferTypeLabel(data.type) }}
                </span>
            </template>
            <template #footer="{ data }">
                <div v-if="stat.obj_types" class="flex flex flex-column">
                    <span class="text-xs mb-2">Тип</span>
                    <span v-for="(type, i) of stat.obj_types" class="text-xs mb-1 font-medium white-space-nowrap">
                        {{ getTranferTypeLabel(i) }}
                    </span>
                </div>
            </template>
        </Column> -->

        <Column field="get_payment_system" :showFilterMenu="true" :showFilterMatchModes="false" :exportable="false" v-if="get_column('Плат.сис')">
            <template #header>
            <span class="text-xs">Плат.&nbspсис.приема</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="paymentSystemOptions" optionLabel="title" optionValue="code" placeholder="Все" class="p-column-filter" :showClear="true" :filter="true">
                    <template #option="slotProps">
                        <div class="flex align-items-center gap-2">
                            <Avatar v-if="slotProps.option.code" :image="getPaySysImage(slotProps.option.code)" class="surface-0" shape="circle" style="width:22px!important;height:22px!important;" />
                            <span>{{ slotProps.option.title }}</span>
                        </div>
                    </template>
                </Dropdown>
            </template>
            <template #body="{ data }">
                <span class="text-xs" v-if="data.get && data.get.code">
                    {{ getPaySysTitle(data.get.code) }}
                </span>
            </template>
        </Column>

        <Column field="sender_amount_" :exportable="false" :showFilterMenu="true" filterMatchMode="contains" :showFilterMatchModes="false" :showFilterOperator="false">
            <template #header>
                <span class="text-xs">Сумма прием.</span>
            </template>
            <template #filter="{ filterModel }">
                <InputNumber v-model="filterModel.value" mode="decimal" />
            </template>
            <template #body="{data}">
                <div class="flex flex-row align-items-center gap-2">
                    <AvatarGroup v-if="data.sender && data.sender.currency_code" class="flex">
                        <Avatar :image="getCurImage(data.sender.currency_code)" class="flex border-1 border-100" shape="circle" style="width:22px!important;height:22px!important;"  />
                    </AvatarGroup>
                    <span class="text-xs font-medium flex">{{ get_format_amount(data.sender.amount, data.sender.currency_code) }}</span>
                </div>
            </template>
            <template #footer="{ data }">
                <div v-if="stat.obj_sender_amounts" class="flex flex flex-column">
                    <span class="text-xs mb-2">Сумма прием.</span>
                    <span v-for="(amount, i) of stat.obj_sender_amounts" class="text-xs mb-1 font-medium white-space-nowrap">
                        {{ get_format_amount(amount, i) }}
                    </span>
                </div>
            </template>
        </Column>

        <!--сумма отпр. для выгрузки-->
        <Column field="csv_sender_amount" header="Сумма отправки" class="hidden">
            <template #body="slotProps">
                <span class="text-sm">{{ slotProps.data.csv_sender_amount }}</span>
            </template>
        </Column>

        <Column field="sender_currency_code" :showFilterMenu="true" :showFilterMatchModes="false" :exportable="false" v-if="get_column('Валюты')">
            <template #header>
            <span class="text-xs">Валюта прием.</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="currencies" optionLabel="code" optionValue="code" placeholder="Все" :filter="true" class="p-column-filter" :showClear="true" />
            </template>
            <template #body="{ data }">
                <span class="text-xs uppercase">{{ data.sender.currency_code }}</span>
            </template>
        </Column>

        <!-- валюта для выгрузки-->
        <Column field="sender_currency_code" header="Валюта&nbspприем." :showFilterMenu="true" :showFilterMatchModes="false" applyButtonLabel="okkk" class="hidden">
            <template #body="{ data }">
                <span class="text-sm">{{ data.sender.currency_code }}</span>
            </template>
        </Column>

        <Column field="sender_bank_code" :showFilterMenu="true" :showFilterMatchModes="false" v-if="get_column('Банки')">
            <template #header>
            <span class="text-xs">Б.отпр.</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="bank_list" optionLabel="name" optionValue="code" placeholder="Все" :filter="true" class="p-column-filter" :showClear="true" />
            </template>
            <template #body="slotProps">
                <div class="flex flex-row align-items-center">
                    <img :src="getBankImage(slotProps.data.sender.bank_code)" class="flex mr-2" style="width:20px">
                    <span class="text-xs flex">{{ getBankTitle(slotProps.data.sender.bank_code) }}</span>
                </div>
            </template>
        </Column>

        <Column field="rate" :exportable="false" v-if="get_column('Курс')">
            <template #header>
            <span class="text-xs">Курс</span>
            </template>
            <template #body="slotProps">
                <span class="text-xs">{{ formatRate(slotProps.data.rate) }}</span>
            </template>
            <template #footer="{ data }">
                <div v-if="stat.obj_rates" class="flex flex flex-column">
                    <span class="text-xs mb-2">Курс.сред.</span>
                    <span v-for="(rate, i) of stat.obj_rates" class="text-xs mb-1 font-medium white-space-nowrap">
                        <span v-if="rate.average">{{ rate.average }} <span class="uppercase">{{ i }}</span> </span>
                    </span>
                </div>
            </template>
        </Column>

        <Column field="send_payment_system" :showFilterMenu="true" :showFilterMatchModes="false" :exportable="false" v-if="get_column('Плат.сис')">
            <template #header>
            <span class="text-xs">Плат.&nbspсис.отпр.</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="paymentSystemOptions" optionLabel="title" optionValue="code" placeholder="Все" class="p-column-filter" :showClear="true" :filter="true">
                    <template #option="slotProps">
                        <div class="flex align-items-center gap-2">
                            <Avatar v-if="slotProps.option.code" :image="getPaySysImage(slotProps.option.code)" class="surface-0" shape="circle" style="width:22px!important;height:22px!important;" />
                            <span>{{ slotProps.option.title }}</span>
                        </div>
                    </template>
                </Dropdown>
            </template>
            <template #body="{ data }">
                <span class="text-xs" v-if="data.send && data.send.code">
                    {{ getPaySysTitle(data.send.code) }}
                </span>
            </template>
        </Column>

        <Column field="recipient_amount_" :exportable="false" :showFilterMenu="true" filterMatchMode="contains" :showFilterMatchModes="false" :showFilterOperator="false">
            <template #header>
            <span class="text-xs">Сумма выпл.</span>
            </template>
            <template #filter="{ filterModel }">
                <InputNumber v-model="filterModel.value" mode="decimal" />
            </template>
            <template #body="{data}">
                <div class="flex flex-row align-items-center gap-2">
                    <AvatarGroup v-if="data.recipient && data.recipient.currency_code" class="flex">
                        <Avatar :image="getCurImage(data.recipient.currency_code)" class="flex border-1 border-100" shape="circle" style="width:22px!important;height:22px!important;"  />
                    </AvatarGroup>
                    <span class="text-xs font-medium flex">{{ get_format_amount(data.recipient.amount, data.recipient.currency_code) }}</span>
                </div>
            </template>
            <template #footer="{ data }">
                <div v-if="stat.obj_recipient_amounts" class="flex flex flex-column">
                    <span class="text-xs mb-2">Сумма выпл.</span>
                    <span v-for="(amount, i) of stat.obj_recipient_amounts" class="text-xs mb-1 font-medium white-space-nowrap">
                        {{ get_format_amount(amount, i) }}
                    </span>
                </div>
            </template>
        </Column>
        
        <!--сумма получ. для выгрузки-->
        <Column field="csv_recipient_amount" header="Сумма получения" class="hidden">
            <template #body="slotProps">
                <span class="text-sm">{{ slotProps.data.csv_recipient_amount }}</span>
            </template>
        </Column>

        <Column field="recipient_currency_code" :showFilterMenu="true" :showFilterMatchModes="false" :exportable="false" v-if="get_column('Валюты')">
            <template #header>
            <span class="text-xs">Валюта выпл.</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="currencies" optionLabel="code" optionValue="code" placeholder="Все" :filter="true" class="p-column-filter" :showClear="true" />
            </template>
            <template #body="{ data }">
                <span class="text-xs uppercase">{{ data.recipient.currency_code }}</span>
            </template>
        </Column>

        <Column field="recipient_bank_code" :showFilterMenu="true" :showFilterMatchModes="false" v-if="get_column('Банки')">
            <template #header>
            <span class="text-xs">Б.выпл.</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="bank_list" optionLabel="name" optionValue="code" placeholder="Все" :filter="true" class="p-column-filter" :showClear="true" />
            </template>
            <template #body="slotProps">
                <div class="flex flex-row align-items-center">
                    <img :src="getBankImage(slotProps.data.recipient.bank_code)" class="flex mr-2" style="width:20px">
                    <span class="text-xs flex">{{ getBankTitle(slotProps.data.recipient.bank_code) }}</span>
                </div>
            </template>
        </Column>

        <Column field="recipient_currency_code" header="Валюта&nbspполуч." :showFilterMenu="true" :showFilterMatchModes="false" applyButtonLabel="okkk" class="hidden">
            <template #body="{ data }">
                <span class="text-sm">{{ data.recipient.currency_code }}</span>
            </template>
        </Column>

        <Column field="service_amount">
            <template #header>
                <span class="text-xs">Сумма в USDT</span>
            </template>
            <template #body="slotProps">
                <div v-if="slotProps.data.service && slotProps.data.service.amount"
                    class="flex flex-row align-items-center">
                    <span class="text-xs white-space-nowrap">{{ get_format_amount(slotProps.data.service.amount, 'usdt') }}</span>
                </div>
            </template>
            <template #footer="{ data }">
                <div v-if="stat.service_amount" class="flex flex flex-column">
                    <span class="text-xs mb-2">Оборот</span>
                    <span class="text-xs mb-1 font-medium white-space-nowrap">
                        {{ get_format_amount(stat.service_amount, 'usdt') }}
                    </span>
                </div>
            </template>
        </Column>

        <Column field="sender_confirm" :showFilterMenu="true" :exportable="false" v-if="get_column('Отметки')">
            <template #header>
            <span class="text-xs">Отм.&nbspкл</span>
            </template>
            <template #body="{ data }">
                <span :class="(data.sender.confirm) ? 'bg-green-400 border-round-md font-medium p-1 text-white' : ''" class="text-xs">
                    {{(data.sender.confirm) ? 'Да' : 'Нет'}}
                </span> 
            </template>
        </Column>

        <Column field="get_merchant_confirm" :showFilterMenu="false" :showFilterMatchModes="false" :exportable="false" v-if="get_column('Отметки')">
            <template #header>
            <span class="text-xs">Отм.мрч.(пол)</span>
            </template>
            <template #body="{ data }">
                <span :class="(data.get.merchant.confirm)? 'bg-green-400 border-round-md font-medium p-1 text-white' : ''" class="text-xs">
                    {{(data.get_merchant_confirm) ? 'Получ.' : 'Нет'}}
                </span> 
            </template>
        </Column>

        <Column field="send_merchant_confirm" :showFilterMenu="false" :showFilterMatchModes="false" :exportable="false" v-if="get_column('Отметки')">
            <template #header>
            <span class="text-xs">Отм.мрч.(отп)</span>
            </template>
            <template #body="{ data }">
                <span :class="(data.send.merchant.confirm)? 'bg-green-400 border-round-md font-medium p-1 text-white' : ''" class="text-xs">
                    {{(data.send.merchant.confirm) ? 'Отпр.' : 'Нет'}}
                </span> 
            </template>
        </Column>

        <!--сумма сервиса для выгрузки-->
        <Column field="csv_service_amount" header="Сумма перевода (USD)" class="hidden">
            <template #body="{ data }"> 
                <span class="text-sm">{{ data.csv_service_amount }}</span>
            </template>
        </Column>

        <!--комиссия сервиса для выгрузки-->
        <Column field="csv_comission_service" header="Комиссия сервиса (USD)" class="hidden">
            <template #body="{ data }"> 
                <span class="text-sm">{{ data.csv_comission_service }}</span>
            </template>
        </Column>

        <!--комиссия мерчанта получения для выгрузки-->
        <Column field="csv_comission_get_merch" header="Комиссия мерчанта (USD)" class="hidden">
            <template #body="{ data }"> 
                <span class="text-sm">{{ data.csv_comission_get_merch }}</span>
            </template>
        </Column>

        <!--комиссия мерчанта отправки для выгрузки-->
        <Column field="csv_comission_send_merch" header="Комиссия мерчанта (USD)" class="hidden">
            <template #body="{ data }"> 
                <span class="text-sm">{{ data.csv_comission_send_merch }}</span>
            </template>
        </Column>

        <Column field="get_merchant_reward_paid" :showFilterMenu="false" :showFilterMatchModes="false" v-if="get_column('Отметки')">
            <template #header>
            <span class="text-xs">Выпл.мерч.(пол)</span>
            </template>
            <template #body="{ data }">
                <span :class="(data.get.merchant.reward_paid)? 'bg-green-400 border-round-md font-medium p-1 text-white' : ''" class="text-xs white-space-nowrap">
                    {{(data.get.merchant.reward_paid) ? 'Выпл.' : 'Нет'}}
                </span> 
            </template>
        </Column>

        <Column field="send_merchant_reward_paid"  :showFilterMenu="false" :showFilterMatchModes="false" v-if="get_column('Отметки')">
            <template #header>
            <span class="text-xs">Выпл.мерч.(отп)</span>
            </template>
            <template #body="{ data }">
                <span :class="(data.send.merchant.reward_paid)? 'bg-green-400 border-round-md font-medium p-1 text-white' : ''" class="text-xs white-space-nowrap">
                    {{(data.send.merchant.reward_paid) ? 'Выпл.' : 'Нет'}}
                </span> 
            </template>
        </Column>

        <Column field="send_merchant_bank_paid"  :showFilterMenu="false" :showFilterMatchModes="false" v-if="get_column('Отметки')">
            <template #header>
            <span class="text-xs">Выпл.банка(отп)</span>
            </template>
            <template #body="{ data }">
                <span :class="(data.send.merchant.bank_paid)? 'bg-green-400 border-round-md font-medium p-1 text-white' : ''" class="text-xs white-space-nowrap">
                    {{(data.send.merchant.bank_paid) ? 'Выпл.' : 'Нет'}}
                </span> 
            </template>
        </Column>

        <Column field="cashback_amount" header="" :exportable="false" v-if="get_column('Партнер')">
            <template #header>
            <span class="text-xs">Кэшбэк</span>
            </template>
            <template #body="{ data }"> 
                <span v-if="data.cashback && data.cashback.amount"
                    class="text-sm white-space-nowrap"
                    :class="(data.cashback.finalized) ? 'text-orange-600' : 'text-500'">
                    - {{ get_format_amount(data.cashback.amount, 'usdt') }}
                </span>
            </template>
        </Column>

        <Column field="partner_reward_amount" header="" :exportable="false" v-if="get_column('Партнер')">
            <template #header>
            <span class="text-xs">К.парт.</span>
            </template>
            <template #body="{ data }"> 
                <span v-if="data.partner && data.partner.amount && data.partner.amount"
                    class="text-sm white-space-nowrap" 
                    :class="(data.partner.payout) ? 'text-green-600' : 'text-500'">
                    + {{ get_format_amount(data.partner.amount, 'usdt') }}
                </span>
            </template>
            <template #footer="{ data }">
                <span class="text-xs font-medium white-space-nowrap">
                    К.парт:<br>
                    {{ get_format_amount(stat.partner_reward_amount, 'usdt') }}
                </span>
            </template>
        </Column>
        
        <Column field="partner" header="" v-if="get_column('Партнер')">
            <template #header>
            <span class="text-xs">Партнер</span>
            </template>
            <template #body="{ data }">
                <div v-if="data.partner && data.partner.user_id" class="flex flex-row gap-1 text-xs white-space-nowrap align-items-center">
                    <span class="flex text-primary text-xs">
                        {{ get_short_id(data.partner.user_id) }}
                    </span>
                    <Button icon="pi pi-external-link" @click="go_to_user(data.partner.user_id)" size="small" text severity="info" class="flex"/>
                </div>
            </template>
            <template #footer="{ data }">
                <span class="text-xs font-medium white-space-nowrap">
                    Партнер:<br>
                    {{ stat.partner_paids_total }}
                </span>
            </template>
        </Column>

        <!--Комиссия партнера для выгрузки-->
        <Column field="csv_partner_amount" header="Комиссия партнера (USD)" class="hidden">
            <template #body="{data}">
                <!-- <span class="text-sm">{{ data.partner.reward_amount }}</span> -->
            </template>
        </Column>

        <!--курс для выгрузки-->
        <Column field="csv_rate" header="Курс" class="hidden">
            <template #body="slotProps">
                <span class="text-sm">{{ slotProps.data.csv_rate }}</span>
            </template>
        </Column>

        <Column field="date_created" :exportable="false" sortable filterField="date_created" dataType="date" :showFilterMatchModes="false" :showFilterOperator="false">
            <template #header>
            <span class="text-xs">Создан</span>
            </template>
            <template #body="{ data }">
                <small class="text-xs">{{ formatDate(data.dates.created) }}</small>
            </template>
            <template #filter="{ filterModel }">
                <Calendar v-model="filterModel.value" dateFormat="dd.mm.yy" placeholder="dd.mm.yy" mask="99.99.9999" showTime />
            </template>
        </Column>

        <Column field="date_created" :exportable="false" sortable filterField="date_created" dataType="date" :showFilterMatchModes="false" :showFilterOperator="false" v-if="get_column('Даты')">
            <template #header>
            <span class="text-xs">Создан UTC</span>
            </template>
            <template #body="{ data }">
                <small class="text-xs white-space-nowrap">{{ formatDateUTC(data.dates.created) }}</small>
            </template>
            <template #filter="{ filterModel }">
                <Calendar v-model="filterModel.value" dateFormat="dd.mm.yy" placeholder="dd.mm.yy" mask="99.99.9999" />
            </template>
        </Column>

        <!--дата создания для выгрузки-->
        <Column field="csv_date_created" header="Дата создания" class="hidden">
            <template #body="slotProps">
                <span class="text-sm">{{ slotProps.data.csv_date_created }}</span>
            </template>
        </Column>

        <Column field="sender_confirm_date" header="" filterField="sender_confirm_date" dataType="date"  :showFilterMenu="false" :showFilterMatchModes="true" :exportable="false" v-if="get_column('Даты')">
            <template #header>
            <span class="text-xs">Отм.клн</span>
            </template>
            <template #body="{ data }">
                <small class="text-xs">{{ formatDate(data.sender.confirm_date) }}</small>
            </template>
            <template #filter="{ filterModel }">
                <Calendar v-model="filterModel.value" dateFormat="dd.mm.yy" placeholder="dd.mm.yy" mask="99.99.9999" />
            </template>
        </Column>

        <Column field="get_merchant_confirm_date" header="" filterField="get_merchant_confirm_date" dataType="date"  :showFilterMenu="false" :showFilterMatchModes="true" :exportable="false" v-if="get_column('Даты')">
            <template #header>
            <span class="text-xs">Отм.получ.</span>
            </template>
            <template #body="{ data }">
                <small class="text-xs">{{ formatDate(data.get.payment_system.confirm_date) }}</small>
            </template>
            <template #filter="{ filterModel }">
                <Calendar v-model="filterModel.value" dateFormat="dd.mm.yy" placeholder="dd.mm.yy" mask="99.99.9999" />
            </template>
        </Column>

        <Column field="send_merchant_confirm_date" header="" filterField="send_merchant_confirm_date" dataType="date"  :showFilterMenu="false" :showFilterMatchModes="true" :exportable="false" v-if="get_column('Даты')">
            <template #header>
            <span class="text-xs">Отм.выпл.</span>
            </template>
            <template #body="{ data }">
                <small class="text-xs">{{ formatDate(data.send.payment_system.confirm_date) }}</small>
            </template>
            <template #filter="{ filterModel }">
                <Calendar v-model="filterModel.value" dateFormat="dd.mm.yy" placeholder="dd.mm.yy" mask="99.99.9999" />
            </template>
        </Column>

        <Column v-if="get_column('Комиссии')">
            <template #header>
                <span class="text-xs">К.серв</span>
            </template>
            <template #body="{ data }"> 
                <span class="text-sm">
                    {{ get_format_amount(data.service.comission, 'usdt') }}
                </span>
            </template>
            <template #footer="{ data }">
                <span class="text-xs font-medium white-space-nowrap">
                    К.серв:<br>
                    {{ get_format_amount(stat.service_comission, 'usdt') }}
                </span>
            </template>
        </Column>

        <Column v-if="get_column('Комиссии')">
            <template #header>
                <span class="text-xs">К.мрч(пол)</span>
            </template>
            <template #body="{ data }"> 
                <span class="text-sm">
                    {{ get_format_amount(data.get.merchant.reward_amount, 'usdt') }}
                </span>
            </template>
            <template #footer="{ data }">
                <span class="text-xs font-medium white-space-nowrap">
                    К.мрч(пол):<br>
                    {{ get_format_amount(stat.get_merchant_reward_amount, 'usdt') }}
                </span>
            </template>
        </Column>

        <Column v-if="get_column('Комиссии')">
            <template #header>
                <span class="text-xs">К.мрч(отп)</span>
            </template>
            <template #body="{ data }"> 
                <span class="text-sm">
                    {{ get_format_amount(data.send.merchant.reward_amount, 'usdt') }}
                </span>
            </template>
            <template #footer="{ data }">
                <span class="text-xs font-medium white-space-nowrap">
                    К.мрч(отп):<br>
                    {{ get_format_amount(stat.send_merchant_reward_amount, 'usdt') }}
                </span>
            </template>
        </Column>

        <Column v-if="get_column('Комиссии')">
            <template #header>
                <span class="text-xs">К.банка</span>
            </template>
            <template #body="{ data }"> 
                <span class="text-sm" v-if="data.send.merchant.bank_amount && data.send.merchant.bank_amount">
                    {{ get_format_amount(data.send.merchant.bank_amount, 'usdt') }}
                </span>
            </template>
            <template #footer="{ data }">
                <span class="text-xs font-medium white-space-nowrap">
                    К.банка:<br>
                    {{ get_format_amount(stat.send_merchant_bank_amount, 'usdt') }}
                </span>
            </template>
        </Column>

        <Column field="timer_get" header="" filterField="timer_get" :exportable="false" dataType="date"  :showFilterMenu="false" :showFilterMatchModes="true" v-if="get_column('Даты')">
            <template #header>
            <span class="text-xs">Время пол.</span>
            </template>
            <template #body="{ data }">
                <small class="text-xs">{{ data.timer_get }}</small>
            </template>
            <template #filter="{ filterModel }">
                <Calendar v-model="filterModel.value" dateFormat="dd.mm.yy" placeholder="dd.mm.yy" mask="99.99.9999" />
            </template>
            <template #footer="{ data }">
                <span class="text-xs font-medium white-space-nowrap">
                    Время пол:<br>
                    {{ stat.timer_get_total }}
                </span>
            </template>
        </Column>

        <Column field="timer_send" header="" filterField="timer_send" :exportable="false" dataType="date"  :showFilterMenu="false" :showFilterMatchModes="true" v-if="get_column('Даты')">
            <template #header>
            <span class="text-xs">Время отп.</span>
            </template>
            <template #body="{ data }">
                <small class="text-xs">{{ data.timer_send }}</small>
            </template>
            <template #filter="{ filterModel }">
                <Calendar v-model="filterModel.value" dateFormat="dd.mm.yy" placeholder="dd.mm.yy" mask="99.99.9999" />
            </template>
            <template #footer="{ data }">
                <span class="text-xs font-medium white-space-nowrap">
                    Время отп: <br>
                    {{ stat.timer_send_total }}
                </span>
            </template>
        </Column>

        <Column field="timer_total" header="" filterField="timer_total" :exportable="false" dataType="date" :showFilterMenu="false" :showFilterMatchModes="true">
            <template #header>
            <span class="text-xs">Общ.время</span>
            </template>
            <template #body="{ data }">
                <small class="text-xs">{{ data.timer_total }}</small>
            </template>
            <template #filter="{ filterModel }">
                <Calendar v-model="filterModel.value" dateFormat="dd.mm.yy" placeholder="dd.mm.yy" mask="99.99.9999" />
            </template>
            <template #footer="{ data }">
                <span class="text-xs font-medium white-space-nowrap">
                    Общ.время: <br>
                    {{ stat.timer_total }}
                </span>
            </template>
        </Column>

        <!--таймер для выгрузки-->
        <Column field="timer_get_seconds" header="Время перевода 1&nbsp" class="hidden">
            <template #body="slotProps">
                <span class="text-sm">{{ slotProps.data.timer_get_seconds }}</span>
            </template>
        </Column>

        <Column field="timer_send_seconds" header="Время перевода 2&nbsp" class="hidden">
            <template #body="slotProps">
                <span class="text-sm">{{ slotProps.data.timer_send_seconds }}</span>
            </template>
        </Column>

        <Column field="timer_total_seconds" header="Суммарное время&nbsp" class="hidden">
            <template #body="slotProps">
                <span class="text-sm">{{ slotProps.data.timer_total_seconds }}</span>
            </template>
        </Column>

        <!--UTMs-->
        <Column field="utm" header="" v-if="get_column('utm')" :exportable="false">
            <template #header>
            <span class="text-xs">utm_source</span>
            </template>
            <template #body="{ data }">
                <span class="text-xs" v-if="users[data.sender.user_id] && users[data.sender.user_id].utm_source">{{ users[data.sender.user_id].utm_source }}</span>
            </template>
            <template #footer="{ data }">
                <span class="text-xs font-medium white-space-nowrap">
                    utm_source:<br>
                    {{ stat.utm_source_count }}
                </span>
            </template>
        </Column>

        <Column field="utm" header="" v-if="get_column('utm')" :exportable="false">
            <template #header>
            <span class="text-xs">utm_medium</span>
            </template>
            <template #body="{ data }">
                <span class="text-xs" v-if="users[data.sender.user_id] && users[data.sender.user_id].utm_medium">{{ users[data.sender.user_id].utm_medium }}</span>
            </template>
            <template #footer="{ data }">
                <span class="text-xs font-medium white-space-nowrap">
                    utm_medium:<br>
                    {{ stat.utm_medium_count }}
                </span>
            </template>
        </Column>

        <Column field="utm" header="" v-if="get_column('utm')" :exportable="false">
            <template #header>
            <span class="text-xs">utm_campaign</span>
            </template>
            <template #body="{ data }">
                <span class="text-xs" v-if="users[data.sender.user_id] && users[data.sender.user_id].utm_campaign">{{ users[data.sender.user_id].utm_campaign }}</span>
            </template>
            <template #footer="{ data }">
                <span class="text-xs font-medium white-space-nowrap">
                    utm_campaign:<br>
                    {{ stat.utm_campaign_count }}
                </span>
            </template>
        </Column>

        <Column field="utm" header="" v-if="get_column('utm')" :exportable="false">
            <template #header>
            <span class="text-xs">utm_term</span>
            </template>
            <template #body="{ data }">
                <span class="text-xs" v-if="users[data.sender.user_id] && users[data.sender.user_id].utm_term">{{ users[data.sender.user_id].utm_term }}</span>
            </template>
            <template #footer="{ data }">
                <span class="text-xs font-medium white-space-nowrap">
                    utm_term:<br>
                    {{ stat.utm_term_count }}
                </span>
            </template>
        </Column>

        <Column field="utm" header="" v-if="get_column('utm')" :exportable="false">
            <template #header>
            <span class="text-xs">utm_content</span>
            </template>
            <template #body="{ data }">
                <span class="text-xs" v-if="users[data.sender.user_id] && users[data.sender.user_id].utm_content">{{ users[data.sender.user_id].utm_content }}</span>
            </template>
            <template #footer="{ data }">
                <span class="text-xs font-medium white-space-nowrap">
                    utm_content:<br>
                    {{ stat.utm_content_count }}
                </span>
            </template>
        </Column>

        <template #footer>
            <span class="text-sm font-medium">
                Всего {{ totalRecords }} переводов на сумму {{ get_format_amount(stat.service_amount, 'usdt') }}
            </span>
        </template>

    </DataTable>
    <Skeleton height="2rem" v-else class="mx-2"/>


    <Dialog header="Файл" v-model:visible="popupFile" modal :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}" @hide="closePopupImage">
        <div class="h-full flex flex-column">
            <a v-if="popupFile" :href="popupFileUrl" download class="mb-1">Скачать</a>
            <img v-if="popupFile" :src="popupFileUrl" class="w-full"> 
            <span v-else>Файл не найден</span>
        </div>
    </Dialog>

    <Dialog header="Описание" v-model:visible="popupText" modal :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}" @hide="closePopupImage">
        <div class="flex flex-column">
            <div v-if="popupTextSender" class="mb-3 flex flex-column">
                <span class="flex mb-2">Коментарий отправителя:</span>
                <InlineMessage severity="secondary" class="border-round-md justify-content-start">
                    <span class="text-left text-xs xl:text-md lg:text-sm">
                        {{ popupTextSender }}
                    </span>
                </InlineMessage>
            </div>
            <div v-if="popupTextRecipient" class="mb-3 flex flex-column">
                <span class="flex mb-2">Коментарий получателя:</span>
                <InlineMessage severity="secondary" class="border-round-md justify-content-start">
                    <span class="text-left text-xs xl:text-md lg:text-sm">
                        {{ popupTextRecipient }}
                    </span>
                </InlineMessage>
            </div>
        </div>
    </Dialog>

    <Dialog header="Получатели" v-model:visible="popupRecipients" modal :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}" @hide="closeRecipientsPopup">
        <div v-if="popupRecipientsArr" class="h-full flex flex-column">
            <div v-for="[k,v] of Object.entries(popupRecipientsArr)" class="w-full mb-2 surface-100 p-3 border-round-lg">
                <Recipient :recipient="v" />
            </div>
        </div>
    </Dialog>

</template>


<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import BigNumber from 'bignumber.js'
import { FilterMatchMode, FilterOperator } from '@primevue/core/api';
import Recipient from '@/components/widgets/Recipient.vue'
import PageFull from '@/components/sides/PageFull.vue'
import { BankList, PaymentSystemList } from '@/assets/js/classes/PaymentSystem.js'
import { CurrencyList } from '@/assets/js/classes/Currency.js'

export default {
    data() {
        return {
            transfers: null,
            user_loaded: false,
            lazyParams: {},
            dt: null,
            totalRecords: 0,
            transfers: null,
            selectedTransfers: null,
            selectAll: false,
            loading: false,
            loadReceipt: false,
            popupFile: false,
            popupFileUrl: null,
            popupRecipients: false,
            popupRecipientsArr: [],
            popupText: false,
            popupTextSender: null,
            popupTextRecipient: null,
            receipts: [],
            users: {},
            merchants: [],
            filters: {
                _id: {value: '', matchMode: 'contains'},
                sender_user_id: {value: '', matchMode: 'contains'},
                get_merchant_merchant_id: {value: '', matchMode: 'contains'},
                send_merchant_merchant_id: {value: '', matchMode: 'contains'},
                status: {value: '', matchMode: 'contains'},
                sender_amount_: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                sender_currency_code: {value: '', matchMode: 'contains'},
                sender_bank_code: {value: '', matchMode: 'contains'},
                recipient_amount_: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                recipient_currency_code: {value: '', matchMode: 'contains'},
                recipient_bank_code: {value: '', matchMode: 'contains'},
                payment_system: {value: '', matchMode: 'contains'},
                get_payment_system: {value: '', matchMode: 'contains'},
                send_payment_system: {value: '', matchMode: 'contains'},
                date_created: { 
                    operator: FilterOperator.AND, 
                    constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] 
                },
            },
            sort: {
                field: 'date_created',
                order: -1
            },
            columns: [
                {field: 'Плат.сис', header: 'Плат.сис'},
                {field: 'Валюты', header: 'Валюты'},
                {field: 'Банки', header: 'Банки'},
                {field: 'Курс', header: 'Курс'},
                {field: 'Отметки', header: 'Отметки'},
                {field: 'Партнер', header: 'Партнер'},
                {field: 'Даты', header: 'Даты'},
                {field: 'Комиссии', header: 'Комиссии'},
                {field: 'utm', header: 'utm'},
            ],
            selectedColumns: [],
            statuses: ['confirmation', 'completed', 'process', 'created', 'closed', 'expired'],
            bank_list: [],
            payment_systems: [],
            paymentSystemOptions: [],
            currencies: [],
            stat: {
                service_amount: null,
                service_comission: null,
                get_merchant_reward_amount: null,
                send_merchant_reward_amount: null,
                send_merchant_bank_amount: null,
                partner_reward_amount: null,
                partner_paids_total: null,
                timer_get_total: null,
                timer_send_total: null,
                timer_total: null,
                utm_source_count: null,
                utm_medium_count: null,
                utm_campaign_count: null,
                utm_term_count: null,
                utm_content_count: null,

                obj_sender_amounts: {},
                obj_recipient_amounts: {},
                obj_rates: {},
                obj_types: {},
                obj_sources: {
                    web: 0,
                    tgapp: 0
                },

                uniq_senders: null
            }
        }
    },
    components: {
        Recipient,
        PageFull
    },
    methods: {
        getStep(tr, step){
            if  (!tr || !step) return false
            if  (tr.sender && tr.sender.confirm && step == 1) return true
            if  (tr.get && 
                ((tr.get.merchant && tr.get.merchant.confirm) || (tr.get.payment_system && tr.get.payment_system.confirm)) &&
                step == 2) return true
            if  (tr.send && 
                ((tr.send.merchant && tr.send.merchant.confirm) || (tr.send.payment_system && tr.send.payment_system.confirm)) &&
                step == 3) return true
            if  (tr.recipient && tr.recipient.confirm && step == 4) return true
            return false
        },
        getTranferTypeClass(type){
            return this.helper.get_transfer_type_class(type)
        },
        getTranferSeverity(type){
            return this.helper.get_transfer_severity(type)
        },
        getTranferTypeLabel(type){
            return this.helper.get_transfer_type_label(type)
        },
        getTranferTypeIcon(type){
            return this.helper.get_transfer_type_icon(type)
        },
        get_timer(seconds){
            return this.helper.get_timer(seconds)
        },
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        get_column(val) {
            for(const [k,v] of Object.entries(this.selectedColumns)){
                if(v.field == val && v.header == val)return true
            }
        },
        onToggle: function (e) {
            if(e.length>0){
                this.selectedColumns = e
            } else {
                this.selectedColumns = []
            }
        },
        exportCSV(){
            this.$refs.dt.exportCSV();
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        getBankTitle(code){
            let bankObj = new BankList()
            bankObj.items = this.bank_list
            const bankCode = bankObj.GetTitle(code, this.lang_)
            return (bankCode) ? bankCode : code
        },
        getBankImage(code){
            let bankObj = new BankList()
            bankObj.items = this.bank_list
            const bankCode = bankObj.GetImage(code)
            return (bankCode) ? bankCode : null
        },
        getPaySysTitle(code){
            let paySysObj = new PaymentSystemList()
            paySysObj.items = this.payment_systems
            const paySysCode = paySysObj.GetTitle(code, this.lang_)
            return (paySysCode) ? paySysCode : code
        },
        getPaySysImage(code){
            let paySysObj = new PaymentSystemList()
            paySysObj.items = this.payment_systems
            const paySysCode = paySysObj.GetImage(code)
            return (paySysCode) ? paySysCode : null
        },
        getCurImage(code){
            let currencyObj = new CurrencyList()
            currencyObj.items = this.currencies
            const currencyCode = currencyObj.GetImage(code)
            return (currencyCode) ? currencyCode : null
        },
        go_to_user(id){
            const go = this.$router.resolve({path: '/admin/user/' + id})
            window.open(go.href, '_blank')
        },
        goToMerchant(id){
            const go = this.$router.resolve({path: '/admin/merchant/' + id})
            window.open(go.href, '_blank')
        },
        filterUser(id){
            this.filters.sender_user_id = {value: id, matchMode: 'contains'}
            this.onFilter()
        },
        get_format_amount(value, currency) {
            return this.helper.format_amount(value, currency)
        },
        formatRate(value) {
            return this.helper.format_rate(value)
        },
        toUpperCase(value) {
            if (!value) return ''
            if(typeof value != 'string') return ''
            return String(value)
        },
        detail_page(id, new_tab = false) {
            if(new_tab){
                const routeData = this.$router.resolve({path: '/admin/transfer/' + id});
                window.open(routeData.href, '_blank');
            } else  this.$router.push({ path: '/admin/transfer/' + id })
        },
        toOps(id){
            if(!id) return
            window.open(`/admin/operations/?transfer_id=${id}`, '_blank')
        },
        formatDate(value) {
            return this.helper.format_date(value)
        },
        formatDateUTC(value) {
            const date = new Date(value)
            const utcDate = date.toISOString().slice(0, 19).replace('T', ' ')
            return this.helper.format_date(utcDate)
        },
        get_currency_label(value) {
            return this.helper.get_currency_label(value)
        },
        get_token_label(value) {
            return this.helper.get_token_label(value)
        },
        getStatusLabel (status) {
            return this.helper.get_severity_status(status, this.lang_)
        },
        getSeverity (status) {
            return this.helper.get_severity_from_status(status)
        },
        get_short_id(value){
            return this.helper.get_short_id(value)
        },
        get_short_name(value){
            return this.helper.get_short_name(value, 12)
        },
        getClassFromRiskLevel(data) {
            if(!data || !data.risk?.level) return 'gray'
            const lvl = data.risk.level.toLowerCase()
            switch (lvl) {
                case 'very_low':
                    return 'limegreen'
                case 'low':
                    return 'yellowgreen'
                case 'medium':
                    return 'gold'
                case 'high':
                    return 'orange'
                case 'critical':
                    return 'crimson'
                default:
                    return 'gray'
            }
        },
        formatRiskFactorValue(value) {
            if (typeof value === 'boolean') return value ? 'true' : 'false'
            if (value === null || value === undefined) return '-'
            if (typeof value === 'object') return JSON.stringify(value)
            return String(value)
        },
        getRiskDetails(data) {
            if(!data || !data.risk) return ''

            const details = []
            if (data.risk.details) details.push(String(data.risk.details))

            const factors = Array.isArray(data.risk.factors) ? data.risk.factors : []
            if (factors.length) {
                details.push('Факторы риска:')
                factors.forEach((factor, index) => {
                    if (!factor) return
                    const description = factor.description_ru || factor.description || factor.code || 'Без описания'
                    const type = factor.type ? ` [${factor.type}]` : ''
                    const score = factor.score !== undefined && factor.score !== null ? `, score: ${factor.score}` : ''
                    const value = factor.value !== undefined ? `, value: ${this.formatRiskFactorValue(factor.value)}` : ''
                    details.push(`${index + 1}. ${description}`)
                })
            }

            return details.join('\n')
        },
        getRiskScore(data) {
            if(!data || !data.risk?.score) return 0
            return data.risk.score
        },
        getLength(arr){
            if(!arr) return 0
            if(typeof arr !='object') return 0
            return arr.length
        },
        onPage(event) {
            this.lazyParams = event
            this.loadTransfers()
        },
        onSort(event) {
            if(event.sortField && event.sortOrder){
                this.sort = {
                    field: event.sortField,
                    order: event.sortOrder
                }
            } else {
                this.sort = {
                    field: 'date_created',
                    order: -1
                }
            }

            this.lazyParams.sort = this.sort
            this.loadTransfers()
        },
        onFilter() {
            this.lazyParams.filters = this.filters
            this.loadTransfers()
        },
        onRowSelect() {
            this.selectAll = this.selectedTransfers.length === this.totalRecords
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        async loadTransfers() {
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' }) //скролл вверх

            // формат суммы с запятой для выгрузки 
            const fmt = {
                prefix: '',
                decimalSeparator: ',',
                groupSeparator: '',
                groupSize: 3,
                secondaryGroupSize: 0,
                fractionGroupSeparator: ' ',
                fractionGroupSize: 0,
                suffix: ''
            }

            let sender_ids = []
            let merchant_ids = []

            // данные для статистики
            let service_amount_total = new BigNumber(0)
            let service_comission_total = new BigNumber(0)
            let get_merchant_reward_amount_total = new BigNumber(0)
            let send_merchant_reward_amount_total = new BigNumber(0)
            let send_merchant_bank_amount_total = new BigNumber(0)
            let timer_get_total = new BigNumber(0)
            let timer_get_transfer_total = 0
            let timer_send_total = new BigNumber(0)
            let timer_send_transfer_total = 0
            let timer_total = new BigNumber(0)
            let timer_transfer_count = 0
            let partner_reward_amount_total = new BigNumber(0)
            let partner_paids_total = 0
            let uniq_senders = 0

            // статистика по utm
            let utm_source_count = 0
            let utm_medium_count = 0
            let utm_campaign_count = 0
            let utm_term_count = 0
            let utm_content_count = 0

            const transfers = await this.connect.transfers_list(this.lazyParams.rows, this.lazyParams.first, this.lazyParams.filters, this.lazyParams.sort).then(res => res)
            if(!transfers.result || !transfers.data) {
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка загрузки данных', life: 5000 })
                this.loading = false
                return
            } 

            if(transfers.data.length == 0){
                this.$toast.add({ severity: 'info', summary: 'Информация', detail: 'Нет данных', life: 5000 })
                this.loading = false
                return
            }

            this.transfers = transfers.data
            this.totalRecords = transfers.total

            let ids = []
            for(const [k,v] of Object.entries(transfers.data)){
                if(v.sender && v.sender.user_id) sender_ids.push(v.sender.user_id)
                if(v.get && v.get.merchant && v.get.merchant.merchant_id) merchant_ids.push(v.get.merchant.merchant_id)
                if(v.send && v.send.merchant && v.send.merchant.merchant_id) merchant_ids.push(v.send.merchant.merchant_id)
                if(v.id) ids.push(v.id)

                // считаем время выполнения сделки от подтверждения клиента до подтверждения мерчанта получения
                this.transfers[k].timer_get = ''
                this.transfers[k].timer_get_seconds = ''
                if(v.sender && v.sender.confirm_date && v.get && v.get.payment_system && v.get.payment_system.confirm_date){
                    this.transfers[k].timer_get = this.helper.get_timer(v.sender.confirm_date, v.get.payment_system.confirm_date)
                    this.transfers[k].timer_get_seconds = this.helper.get_timer(v.sender.confirm_date, v.get.payment_system.confirm_date)
                    let t_get_seconds = this.helper.get_seconds(v.sender.confirm_date, v.get.payment_system.confirm_date)
                    let b_get_seconds = new BigNumber(t_get_seconds)
                    timer_get_total = timer_get_total.plus(b_get_seconds)
                    timer_get_transfer_total++
                }
                
                // считаем время выполнения сделки от мерчанта получения до подтверждения мерчанта отправки
                this.transfers[k].timer_send = ''
                this.transfers[k].timer_send_seconds = ''
                if(v.get && v.get.payment_system && v.get.payment_system.confirm_date && v.send && v.send.payment_system && v.send.payment_system.confirm_date){
                    this.transfers[k].timer_send = this.helper.get_timer(v.get.payment_system.confirm_date, v.send.payment_system.confirm_date)
                    this.transfers[k].timer_send_seconds = this.helper.get_timer(v.get.payment_system.confirm_date, v.send.payment_system.confirm_date)
                    let t_send_seconds = this.helper.get_seconds(v.get.payment_system.confirm_date, v.send.payment_system.confirm_date)
                    let b_send_seconds = new BigNumber(t_send_seconds)
                    timer_send_total = timer_send_total.plus(b_send_seconds)
                    timer_send_transfer_total++
                }

                // считаем суммарное время от подтверждения клиента до подтверждения мерчанта отправки
                this.transfers[k].timer_total = ''
                this.transfers[k].timer_total_seconds = ''
                if(v.sender && v.sender.confirm_date && v.send && v.send.payment_system && v.send.payment_system.confirm_date){
                    this.transfers[k].timer_total = this.helper.get_timer(v.sender.confirm_date, v.send.payment_system.confirm_date)
                    this.transfers[k].timer_total_seconds = this.helper.get_timer(v.sender.confirm_date, v.send.payment_system.confirm_date)
                    let t_seconds = this.helper.get_seconds(v.sender.confirm_date, v.send.payment_system.confirm_date)
                    let b_seconds = new BigNumber(t_seconds)
                    timer_total = timer_total.plus(b_seconds)
                    timer_transfer_count++
                }

                // форматируем данные для выгрузки
                let csv_id = this.helper.get_short_id(v.id)
                this.transfers[k].csv_id = csv_id

                let sender_amount = new BigNumber(v.sender.amount)
                this.transfers[k].csv_sender_amount = sender_amount.toFormat(2, fmt)
                this.transfers[k].sender_amount_ = sender_amount.toFormat(2, fmt)

                let recipient_amount = new BigNumber(v.recipient.amount)
                this.transfers[k].csv_recipient_amount = recipient_amount.toFormat(2, fmt)
                this.transfers[k].recipient_amount_ = recipient_amount.toFormat(2, fmt)

                let partner_amount = (v.partner && v.partner.amount && v.partner.amount) ? v.partner.amount : 0
                let b_partner_amount = new BigNumber(partner_amount)
                if(v.partner && v.partner.user_id) {
                    partner_paids_total = partner_paids_total + 1
                    if(b_partner_amount.isGreaterThan(0)) {
                        this.transfers[k].csv_partner_amount = b_partner_amount.toFormat(2, fmt)
                        partner_reward_amount_total = partner_reward_amount_total.plus(b_partner_amount)
                    }
                }
                
                let csv_date_created = this.helper.format_date(v.dates.created)
                this.transfers[k].csv_date_created = csv_date_created

                let csv_rate = new BigNumber(v.rate)
                this.transfers[k].csv_rate = csv_rate.toFormat(2, fmt)

                let comission_service = (v.service && v.service.comission && v.service.comission) ? v.service.comission : 0
                let b_comission_service = new BigNumber(comission_service)
                this.transfers[k].csv_comission_service = b_comission_service.toFormat(6, fmt)
                service_comission_total = service_comission_total.plus(b_comission_service)

                let service_amount = (v.service && v.service.amount && v.service.amount) ? v.service.amount : 0
                let b_service_amount = new BigNumber(service_amount)
                this.transfers[k].csv_service_amount = b_service_amount.toFormat(2, fmt)
                service_amount_total = service_amount_total.plus(b_service_amount)

                let comission_get_merch = (v.get && v.get.merchant && v.get.merchant.reward_amount && v.get.merchant.reward_amount) ? v.get.merchant.reward_amount : 0
                let b_comission_get_merch = new BigNumber(comission_get_merch)
                this.transfers[k].csv_comission_get_merch = b_comission_get_merch.toFormat(6, fmt)
                get_merchant_reward_amount_total = get_merchant_reward_amount_total.plus(b_comission_get_merch)

                let comission_send_merch = (v.send && v.send.merchant && v.send.merchant.reward_amount && v.send.merchant.reward_amount) ? v.send.merchant.reward_amount : 0
                let b_comission_send_merch = new BigNumber(comission_send_merch)
                this.transfers[k].csv_comission_send_merch = b_comission_send_merch.toFormat(6, fmt)
                send_merchant_reward_amount_total = send_merchant_reward_amount_total.plus(b_comission_send_merch)

                // // отмечаем партнера
                // if(v.partner && v.partner.user_id) this.transfers[k].partner = true
            }
            
            this.stat.service_amount = service_amount_total
            this.stat.service_comission = service_comission_total
            this.stat.get_merchant_reward_amount = get_merchant_reward_amount_total
            this.stat.send_merchant_reward_amount = send_merchant_reward_amount_total
            this.stat.send_merchant_bank_amount = send_merchant_bank_amount_total
            this.stat.partner_reward_amount = partner_reward_amount_total.toFixed(2)
            this.stat.partner_paids_total = partner_paids_total

            // форматируем суммарное время
            // общее время выполнения сделки
            if(timer_total>0 && timer_transfer_count>0){
                let average = new BigNumber(0)
                let b_total = new BigNumber(timer_transfer_count)
                average = timer_total.dividedBy(b_total)
                average = average.toFixed(0)
                average = parseInt(average)
                average = average*1000
                this.stat.timer_total = this.helper.get_timer_from_seconds(average)
            }

            // среднее время выполнения сделки от подтверждения клиента до подтверждения мерчанта получения
            if(timer_get_total>0 && timer_get_transfer_total>0){
                let average = new BigNumber(0)
                let b_total = new BigNumber(timer_get_transfer_total)
                average = timer_get_total.dividedBy(b_total)
                average = average.toFixed(0)
                average = parseInt(average)
                average = average*1000
                this.stat.timer_get_total = this.helper.get_timer_from_seconds(average)
            }

            // среднее время выполнения сделки от мерчанта получения до подтверждения мерчанта отправки
            if(timer_send_total>0 && timer_send_transfer_total>0){
                let average = new BigNumber(0)
                let b_total = new BigNumber(timer_send_transfer_total)
                average = timer_send_total.dividedBy(b_total)
                average = average.toFixed(0)
                average = parseInt(average)
                average = average*1000
                this.stat.timer_send_total = this.helper.get_timer_from_seconds(average)
            }

            sender_ids = [...new Set(sender_ids)]
            merchant_ids = [...new Set(merchant_ids)]

            this.stat.uniq_senders = (sender_ids.length) ? sender_ids.length : 0

            // ищем имена пользователей по id
            if(sender_ids.length>0){
                let res = await this.connect.get_users_list_byids(sender_ids, {name:true,utm:true,sendpulse:true,telegram:true,prefix:true,phone:true,notion:true,verified:true}).then(res => res)
                if(res.result){
                    for(const [k,v] of Object.entries(res.data)){
                        this.users[v._id] = {
                            name: v.name,
                            telegram: (v.telegram && v.telegram.username) ? v.telegram.username : null,
                            prefix: (v.prefix) ? v.prefix : null,
                            phone: (v.phone && v.phone) ? v.phone : null,
                            photo_url: (v.telegram && v.telegram.photo_url) ? v.telegram.photo_url : null,
                            sendpulse: (v.sendpulse && v.sendpulse.id) ? v.sendpulse.id : null,
                            utm_source: (v.utm) ? (v.utm.utm_source) ? v.utm.utm_source : '' : '',
                            utm_medium: (v.utm) ? (v.utm.utm_medium) ? v.utm.utm_medium : '' : '',
                            utm_campaign: (v.utm) ? (v.utm.utm_campaign) ? v.utm.utm_campaign : '' : '',
                            utm_term: (v.utm) ? (v.utm.utm_term) ? v.utm.utm_term : '' : '',
                            utm_content: (v.utm) ? (v.utm.utm_content) ? v.utm.utm_content : '' : '',
                            recipients: [],
                            notion: (v.notion) ? v.notion : null,
                            verified: (v.verified) ? v.verified : false
                        }
                    }
                }
            }

             // ищем получателей по id
            if(sender_ids.length>0){
                let res = await this.connect.get_recipients_list_byids(sender_ids, {fields: true, user_id: true, currency_code: true, bank_code: true, confirmed: true, date_created: true}).then(res => res)
                if(res.result && res.data && res.data.length>0){
                    for(const [k,v] of Object.entries(res.data)){
                        if(this.users[v.user_id]){
                            this.users[v.user_id].recipients.push(v)
                        }
                    }
                }
            }

            // впишем UTM в таблицу
            for(const [k,v] of Object.entries(transfers.data)){
                this.transfers[k].utm = {
                    utm_source: (this.users[v.sender.user_id] && this.users[v.sender.user_id].utm_source) ? this.users[v.sender.user_id].utm_source : '',
                    utm_medium: (this.users[v.sender.user_id] && this.users[v.sender.user_id].utm_medium) ? this.users[v.sender.user_id].utm_medium : '',
                    utm_campaign: (this.users[v.sender.user_id] && this.users[v.sender.user_id].utm_campaign) ? this.users[v.sender.user_id].utm_campaign : '',
                    utm_term: (this.users[v.sender.user_id] && this.users[v.sender.user_id].utm_term) ? this.users[v.sender.user_id].utm_term : '',
                    utm_content: (this.users[v.sender.user_id] && this.users[v.sender.user_id].utm_content) ? this.users[v.sender.user_id].utm_content : '',
                }

                if(this.users[v.sender.user_id] && this.users[v.sender.user_id].utm_source)utm_source_count++
                if(this.users[v.sender.user_id] && this.users[v.sender.user_id].utm_medium)utm_medium_count++
                if(this.users[v.sender.user_id] && this.users[v.sender.user_id].utm_campaign)utm_campaign_count++
                if(this.users[v.sender.user_id] && this.users[v.sender.user_id].utm_term)utm_term_count++
                if(this.users[v.sender.user_id] && this.users[v.sender.user_id].utm_content)utm_content_count++
            }

            this.stat.utm_source_count = utm_source_count
            this.stat.utm_medium_count = utm_medium_count
            this.stat.utm_campaign_count = utm_campaign_count
            this.stat.utm_term_count = utm_term_count
            this.stat.utm_content_count = utm_content_count

            // ищем имена мерчантов по id
            if(merchant_ids.length>0){
                let res = await this.connect.get_merchants_list_byids(merchant_ids, {name: true, user_id: true}).then(res => res)
                if(res.result){
                    for(const [k,v] of Object.entries(res.data)){
                        this.merchants.push({
                            code: v._id,
                            name: v.name,
                            user_id: v.user_id
                        })
                    }
                }
            }

            // удалим дубликаты merchants
            if(this.merchants && this.merchants.length>0) this.merchants = this.merchants.filter((v, i, a) => a.findIndex(t => (t.code === v.code)) === i)

            // заполняем имена мерчантов
            for(const [k,v] of Object.entries(transfers.data)){
                this.transfers[k].get_merchant_name = this.getMerchantName(v.get.merchant.merchant_id)
                this.transfers[k].send_merchant_name = this.getMerchantName(v.send.merchant.merchant_id)
            }

            // сформируем объект obj_sender_amounts и obj_recipient_amounts c суммами по валютам + obj_rates + obj_rates
            let obj_sender_amounts = {}
            let obj_recipient_amounts = {}
            let obj_rates = {}
            let obj_types = {}
            let obj_sources = {}
            for(const [k,v] of Object.entries(transfers.data)){
                if(!obj_sender_amounts[v.sender.currency_code]){
                    obj_sender_amounts[v.sender.currency_code] = new BigNumber(0)
                }
                let b_sender_amount = new BigNumber(v.sender.amount)
                obj_sender_amounts[v.sender.currency_code] = obj_sender_amounts[v.sender.currency_code].plus(b_sender_amount)

                if(!obj_recipient_amounts[v.recipient.currency_code]){
                    obj_recipient_amounts[v.recipient.currency_code] = new BigNumber(0)
                }
                let b_recipient_amount = new BigNumber(v.recipient.amount)
                obj_recipient_amounts[v.recipient.currency_code] = obj_recipient_amounts[v.recipient.currency_code].plus(b_recipient_amount)

                if(!obj_rates[v.sender.currency_code]){
                    obj_rates[v.sender.currency_code] = {
                        value: new BigNumber(0),
                        count: 0,
                        average: null
                    }
                }
                let b_rate = new BigNumber(v.rate)
                obj_rates[v.sender.currency_code].value = obj_rates[v.sender.currency_code].value.plus(b_rate)
                obj_rates[v.sender.currency_code].count++

                if(!obj_types[v.type]){
                    obj_types[v.type] = 1
                } else {
                    obj_types[v.type]++
                }

                if(v.source){
                    if(!obj_sources[v.source]){
                        obj_sources[v.source] = 1
                    } else {
                        obj_sources[v.source]++
                    }
                }
            }
            if(obj_sender_amounts && Object.keys(obj_sender_amounts).length>0){
                for(const [k,v] of Object.entries(obj_sender_amounts)){
                    obj_sender_amounts[k] = v.toFixed(2)
                }
            }
            this.stat.obj_sender_amounts = obj_sender_amounts

            if(obj_recipient_amounts && Object.keys(obj_recipient_amounts).length>0){
                for(const [k,v] of Object.entries(obj_recipient_amounts)){
                    obj_recipient_amounts[k] = v.toFixed(2)
                }
            }
            this.stat.obj_recipient_amounts = obj_recipient_amounts

            if(obj_rates && Object.keys(obj_rates).length>0){
                for(const [k,v] of Object.entries(obj_rates)){
                    let average = new BigNumber(0)
                    let b_total = new BigNumber(v.count)
                    if(b_total.isGreaterThan(0)){
                        average = v.value.dividedBy(b_total)
                        if(average.isLessThan(1)){
                            average = new BigNumber(1).dividedBy(average)
                            average = average.toFixed(2)
                        } else {
                            average = average.toFixed(2)
                        }
                        obj_rates[k].average = average
                    }
                }
            }
            this.stat.obj_types = obj_types
            this.stat.obj_rates = obj_rates
            this.stat.obj_sources = obj_sources

            this.loading = false

            this.loadReceipts(ids)
        },
        loadReceipts(ids) {
            if(!ids || ids.length == 0)return
            this.loadReceipt = true
            const rFilter = {transfer_id: { $in: ids } }
            this.connect.files_list(1000, 0, rFilter).then(res => {
                this.receipts = res.data
                this.loadReceipt = false
            })
        },
        getReceiptFromMerchant(merch_id, transfer_id){
            if(!this.receipts || this.receipts.length == 0) return
            if(!this.merchants || this.merchants.length == 0) return
            for(const [k,v] of Object.entries(this.merchants)){
                if(v.code == merch_id){
                    const merch_user_id = v.user_id
                    for(const [k1,v1] of Object.entries(this.receipts)){
                        if(v1.user_id == merch_user_id && v1.transfer_id == transfer_id){
                            if(v1.path) return v1.path
                        }
                    }
                }
            }
            return
        },
        getReceiptFromSender(sender_id, transfer_id){
            if(!this.receipts || this.receipts.length == 0) return
            for(const [k,v] of Object.entries(this.receipts)){
                if(v.user_id == sender_id && v.transfer_id == transfer_id){
                    if(v.path) return v.path
                }
            }
            return
        },
        getWhatsApp(id){
            if(!id) return null
            if(this.users[id] && this.users[id].prefix && this.users[id].phone) return `${this.users[id].prefix}${this.users[id].phone}`
            return null
        },
        goToWhatsApp(number){
            if(!number) return
            window.open('https://wa.me/' + number, '_blank')
            return
        },
        getTelegram(id){
            if(!id) return null
            if(this.users[id] && this.users[id].telegram) return this.users[id].telegram
            return null
        },
        getTelegramPhoto(id){
            if(!id) return null
            if(this.users[id] && this.users[id].photo_url) return this.users[id].photo_url
            return null
        },
        goToTelegram(username){
            if(!username) return
            window.open('https://t.me/' + username, '_blank')
            return
        },
        getSendpulse(id){
            if(!id) return null
            if(this.users[id] && this.users[id].sendpulse) return this.users[id].sendpulse
            return null
        },
        getNotion(id){
            if(!id) return null
            if(this.users[id] && this.users[id].notion && this.users[id].notion.crm_id) return this.users[id].notion.crm_id
            return null
        },
        goToSendpulse(id){
            if(!id) return
            window.open(`https://login.sendpulse.com/chatbots/chats?contact_id=${id}&channel=telegram`, '_blank')
            return
        },
        goToNotion(id){
            if(!id) return
            if(typeof id !== 'string') return
            const str = id.replace(/-/g, '')
            window.open(`https://www.notion.so/pworigin/fe8e29f8f7d84859bb4ccdedb599ebdc?p=${str}`, '_blank')
        },
        openPopupImage(path) {
            if(!path) return
            this.popupFile = true
            this.getFile(path)
        },
        openPopupText(text1, text2) {
            this.popupText = true
            this.popupTextSender = text1
            this.popupTextRecipient = text2
        },
        closePopupImage() {
            this.popupFile = false
            this.popupTextSender = null
            this.popupTextRecipient = null
        },
        closePopupText() {
            this.popupText = false
        },
        openRecipientsPopup(recipients) {
            if(!recipients || recipients.length == 0) return
            this.popupRecipients = true
            this.popupRecipientsArr = recipients
        },
        closeRecipientsPopup() {
            this.popupRecipients = false
            this.popupRecipientsArr = []
        },
        showDescPopup(sender, recipient){
            if(sender) this.descSender = sender
            if(recipient) this.descRecipient = recipient
            this.descPopup = true
        },
        closeDescPopup(){
            this.descSender = null
            this.descRecipient = null
            this.descPopup = false
        },
        async getFile(path) {
            if(!path) return
            const file = await this.connect.get_file(path).then(res => res)
            if (file) {
                const url = window.URL.createObjectURL(new Blob([file]))
                this.popupFileUrl = url
            } else {
                this.popupFileUrl = null
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Файл не найден', life: 3000 })
            }
        },
        getMerchantName(id){
            for(const [k,v] of Object.entries(this.merchants)){
                if(v.code == id)return v.name
            }
            return '-'
        },
        filterFreeTransfers(){
            if(this.filters.free && this.filters.free.value == true){
                this.filters.free = {value: '', matchMode: 'contains'}
            } else {
                this.filters.free = {value: true, matchMode: 'contains'}
            }
            this.onFilter()
        },
        filterActiveTransfers(){
            if(this.filters.status && this.filters.status.value){
                this.filters.status = {value: '', matchMode: 'contains'}
            } else {
                this.filters.status = {
                    value: ['process', 'confirmation', 'created'],
                    matchMode: FilterMatchMode.IN
                }
            }
            this.onFilter()
        },
        isActiveFilter(code){
            for(const [k,v] of Object.entries(this.filters)){
                if(k == code && v.value && v.value !== '' ) return true
            }
            return false
        },
        resetFilter(){
            this.filters = {
                _id: {value: '', matchMode: 'contains'},
                free: {value: '', matchMode: 'contains'},
                sender_id: {value: '', matchMode: 'contains'},
                get_merchant_id: {value: '', matchMode: 'contains'},
                send_merchant_id: {value: '', matchMode: 'contains'},
                status: {value: '', matchMode: 'contains'},
                sender_amount_: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                sender_currency_code: {value: '', matchMode: 'contains'},
                sender_bank_code: {value: '', matchMode: 'contains'},
                recipient_amount_: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                recipient_currency_code: {value: '', matchMode: 'contains'},
                recipient_bank_code: {value: '', matchMode: 'contains'},
                payment_system: {value: '', matchMode: 'contains'},
                get_payment_system: {value: '', matchMode: 'contains'},
                send_payment_system: {value: '', matchMode: 'contains'},
                date_created: { 
                    operator: FilterOperator.AND, 
                    constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] 
                },
            }
            this.lazyParams = {
                first: 0,
                rows: 10,
                sortField: null,
                sortOrder: null,
                filters: this.filters,
            };
            this.loadTransfers()
        },
        async LoadBankList(){
            this.bank_list = await BankList.GetList(this.$store).then(r=>r)
            if(!this.bank_list || !this.bank_list.length) this.bank_list = []
        },
        async LoadPaymentSystems(){
            this.payment_systems = await PaymentSystemList.GetList(this.$store).then(r=>r)
            if(!this.payment_systems || !this.payment_systems.length) {
                this.payment_systems = []
                this.paymentSystemOptions = []
                return
            }
            this.paymentSystemOptions = this.payment_systems.map(p => ({
                code: p.code,
                title: this.getPaySysTitle(p.code)
            }))
        },
        async LoadCurrencyList(){
            this.currencies = await CurrencyList.GetList(this.$store).then(r=>r)
            if(!this.currencies || !this.currencies.length) this.currencies = []
        }
    },
    computed: {
        screenSize() { return this.$store.getters.StateScreenSize },
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru'}
    },
    watch: {},
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.lazyParams = {
            first: 0,
            rows: 10,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
            // sort: 
        }

        // получить get параметр user_id
        const user_id = (this.$route.query.user_id) ? this.$route.query.user_id : null
        if(user_id) this.filters.sender_user_id = {value: user_id, matchMode: 'contains'}

        try { this.loadTransfers()
        } catch (e) { console.log('error', e) }
        try { this.LoadBankList()
        } catch (e) { console.log('error', e) }
        try { this.LoadCurrencyList()
        } catch (e) { console.log('error', e) }
        try { this.LoadPaymentSystems()
        } catch (e) { console.log('error', e) }
    }
}

</script>